/** @jsx jsx */
import React from 'react'
import { jsx, Themed } from 'theme-ui'
import { useEntity } from '../helpers/selectors'
import { cf2imgix } from '../helpers/imgix-image'
import { EVEntry } from '../helpers/react'
import Checklist from '../checklist'
import { Button, Image } from '../../atoms'

const styles = (element) => `compounds.heroCard.variants${element ? `.${element}` : ''}`

const PreviewHeroCard = ({ title, checklist, ctaLink, ctaText, bgImage }): JSX.Element => {
  const checklistEntity = useEntity(checklist)

  return (
    <div className='hero-card__preview'>
      <div className='hero-card__preview-content'>
        <h2>{title}</h2>
        {checklist && <Checklist {...checklistEntity} />}
        {ctaText && ctaLink && (
          <Button variant='primary' href={ctaLink} withIcon={true} size='lg'>
            {ctaText}
          </Button>
        )}
      </div>
      <div className='hero-card__preview-image'>
        <Image src={bgImage} variant='large' alt={title} critical={false} />
      </div>
    </div>
  )
}

const HeroCard = (props) => {
  const { title, bgImage, links, type = 'default' } = props

  const image = useEntity(bgImage)
  const backgroundImage = cf2imgix(image?.file?.url)

  if (type === 'preview') {
    return <PreviewHeroCard {...{ ...props, bgImage: backgroundImage }} />
  }

  return (
    <div
      sx={{
        display: 'flex',
        variant: styles(type === 'seasonal' ? 'seasonal' : ''),
      }}
    >
      <div sx={{ variant: styles('flexContainer') }}>
        <Themed.h1 as='h2'>{title}</Themed.h1>
        {type === 'seasonal' && (
          <div
            sx={{
              variant: styles('links.seasonal'),
            }}
          >
            {links?.map((entity: any, i: number) => {
              return <EVEntry {...entity} key={i} />
            })}
          </div>
        )}
      </div>
      {type === 'default' && (
        <div
          sx={{
            variant: styles('links'),
          }}
        >
          {links?.map((entity: any, i: number) => {
            return <EVEntry {...entity} key={i} />
          })}{' '}
        </div>
      )}
      {backgroundImage && (
        <div
          sx={{
            display: ['none', 'none', 'block'],
            background: `url(${backgroundImage}) no-repeat right center / contain`,
            width: '404px',
            height: '416px',
          }}
        />
      )}
    </div>
  )
}

export default HeroCard
